import React from 'react';
import { Award, Zap, Fuel } from 'lucide-react';
import { aboutData } from '../../data/mock-v3';

const AboutV3 = () => {
  return (
    <section id="about" className="py-20 lg:py-32 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header con diseño centrado */}
        <div className="text-center max-w-4xl mx-auto mb-20">
          <div className="inline-block px-6 py-3 bg-gradient-to-r from-[#63E61E]/20 to-[#52c518]/20 rounded-full mb-6">
            <span className="text-[#63E61E] font-black text-base tracking-wide">SOBRE NOSOTROS</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-black text-gray-900 mb-8">
            {aboutData.title}
          </h2>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-xl">{aboutData.description}</p>
            <p className="text-xl">{aboutData.description2}</p>
            <p className="text-xl">{aboutData.description3}</p>
          </div>
        </div>

        {/* 2 imágenes minimalistas en grid horizontal */}
        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto mb-16">
          {/* Vehículo Eléctrico - Diseño limpio y minimalista */}
          <div className="group relative">
            <div className="absolute -inset-2 bg-gradient-to-r from-[#63E61E] to-[#52c518] rounded-3xl opacity-75 group-hover:opacity-100 blur group-hover:blur-lg transition-all duration-500"></div>
            <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={aboutData.imageElectric}
                  alt="Vehículo Eléctrico Cargando"
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#63E61E]/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 flex items-center space-x-4 shadow-xl">
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-2xl flex items-center justify-center">
                    <Zap className="w-9 h-9 text-gray-900" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-gray-900 font-black text-2xl mb-1">Vehículo Eléctrico</h3>
                    <p className="text-gray-600 text-base font-medium">Cargando energía limpia del futuro</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Vehículo a Gasolina - Diseño limpio y minimalista */}
          <div className="group relative">
            <div className="absolute -inset-2 bg-gradient-to-r from-gray-600 to-gray-800 rounded-3xl opacity-75 group-hover:opacity-100 blur group-hover:blur-lg transition-all duration-500"></div>
            <div className="relative bg-white rounded-3xl overflow-hidden shadow-2xl">
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={aboutData.imageGasoline}
                  alt="Vehículo a Gasolina"
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6 flex items-center space-x-4 shadow-xl">
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-gray-700 to-gray-900 rounded-2xl flex items-center justify-center">
                    <Fuel className="w-9 h-9 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-gray-900 font-black text-2xl mb-1">Vehículo a Gasolina</h3>
                    <p className="text-gray-600 text-base font-medium">Confiable y eficiente para ti</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Value Proposition con diseño destacado */}
        <div className="max-w-5xl mx-auto mb-16 px-2 sm:px-0">
          <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#63E61E] to-[#52c518] rounded-2xl sm:rounded-3xl blur"></div>
            <div className="relative bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 lg:p-10 shadow-2xl border-2 sm:border-4 border-[#63E61E]">
              <div className="flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-6">
                <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-xl sm:rounded-2xl flex items-center justify-center">
                  <Award className="w-7 h-7 sm:w-9 sm:h-9 lg:w-11 lg:h-11 text-gray-900" />
                </div>
                <div className="flex-1 text-center sm:text-left">
                  <h3 className="font-black text-gray-900 text-xl sm:text-2xl lg:text-3xl mb-2 sm:mb-4">Nuestro Valor Agregado</h3>
                  <p className="text-gray-700 text-sm sm:text-base lg:text-xl leading-relaxed">{aboutData.valueProposition}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Stats con diseño moderno */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6 max-w-6xl mx-auto px-2 sm:px-0">
          {aboutData.stats.map((stat, index) => (
            <div key={index} className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-[#63E61E] to-[#52c518] rounded-xl sm:rounded-2xl opacity-0 group-hover:opacity-100 blur transition-opacity duration-300"></div>
              <div className="relative bg-gradient-to-br from-gray-50 to-white rounded-xl sm:rounded-2xl p-3 sm:p-6 lg:p-8 text-center border-2 border-gray-200 group-hover:border-[#63E61E] transition-all duration-300 shadow-lg h-full flex flex-col justify-center min-h-[110px] sm:min-h-[140px]">
                <div className={`font-black text-[#63E61E] mb-1 sm:mb-3 leading-tight ${
                  stat.number.length > 10 
                    ? 'text-sm sm:text-xl lg:text-3xl' 
                    : 'text-2xl sm:text-4xl lg:text-5xl'
                }`}>
                  {stat.number}
                </div>
                <div className="text-[10px] sm:text-xs lg:text-sm text-gray-600 font-bold uppercase tracking-wide leading-tight">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutV3;
